import React, { useEffect, useRef, useState } from "react";
import { Box, Typography, Button } from "@material-ui/core";

/**
 * QuestionTextBlock
 *
 * Mostra titolo e descrizione di una domanda.
 * - Quando non è espanso (expanded === false), tronca a 2 righe usando classes.clamp2
 * - Misura se c'è overflow per capire se rendere visibile il pulsante "Mostra tutto"
 * - Se expanded === true mostra tutto (niente clamp)
 *
 * Props:
 *  - title: string
 *  - desc: string
 *  - expanded: bool
 *  - onToggleExpand: () => void
 *  - disabledExpand: bool
 *  - classes: { clamp2, expandBtn }
 */
export default function QuestionTextBlock({
  title,
  desc,
  expanded,
  onToggleExpand,
  disabledExpand,
  classes,
}) {
  const titleRef = useRef(null);
  const descRef = useRef(null);

  const [canExpand, setCanExpand] = useState(false);

  useEffect(() => {
    // Valutiamo se serve il bottone di espansione.
    // Lo facciamo solo in base allo stato "collassato" (expanded === false).
    // Se sto vedendo già tutto (expanded === true) continuo a mostrare il bottone
    // SOLO se prima c'era overflow. Quindi manteniamo "true" in quel caso.

    const elList = [titleRef.current, descRef.current].filter(Boolean);

    let overflowFound = false;
    if (!expanded) {
      for (const el of elList) {
        if (!el) continue;
        // Se il contenuto reale è più alto dell'area visibile "clampata",
        // vuol dire che stiamo troncando.
        if (el.scrollHeight > el.clientHeight + 1) {
          overflowFound = true;
          break;
        }
      }
    }

    setCanExpand((prev) => overflowFound || (expanded && prev));
  }, [title, desc, expanded]);

  return (
    <Box>
      <Typography
        variant="body1"
        style={{ fontWeight: 500 }}
        className={!expanded ? classes.clamp2 : undefined}
        ref={titleRef}
      >
        {title}
      </Typography>

      {desc && (
        <Typography
          variant="body2"
          color="textSecondary"
          style={{ marginTop: 4 }}
          className={!expanded ? classes.clamp2 : undefined}
          ref={descRef}
        >
          {desc}
        </Typography>
      )}

      {canExpand && (
        <Box mt={0.5}>
          <Button
            className={classes.expandBtn}
            onClick={onToggleExpand}
            disabled={disabledExpand}
          >
            {expanded ? "Mostra meno" : "Mostra tutto"}
          </Button>
        </Box>
      )}
    </Box>
  );
}
